import { observer } from "mobx-react-lite";
import GlobalMenuView from "./GlobalMenuView";
import { useTranslation } from "react-i18next";
import TopNavQuickActionsView from "./TopNavQuickActionsView";

const TopNavBar = observer(() => {
    const { t } = useTranslation();

    return (
        <nav className="sticky top-0 w-full h-[60px] shadow-md z-50 flex items-center px-4">
            <div className="shrink-0">
                <GlobalMenuView />
            </div>

            <h3 className="flex-1 mx-4 truncate overflow-hidden whitespace-nowrap">
                {t('color_square')}
            </h3>

            <TopNavQuickActionsView />
        </nav>
    );
});

export default TopNavBar;